import React from 'react';
import { Search, FileText, Rocket } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const iconMap = {
  '01': Search,
  '02': FileText,
  '03': Rocket
};

const HowItWorks = () => {
  const { t } = useTranslation();
  
  const steps = [
    {
      number: '01',
      title: t('howItWorks.step1.title'),
      description: t('howItWorks.step1.description')
    },
    {
      number: '02',
      title: t('howItWorks.step2.title'),
      description: t('howItWorks.step2.description')
    },
    {
      number: '03',
      title: t('howItWorks.step3.title'),
      description: t('howItWorks.step3.description')
    }
  ];
  
  return (
    <section className="how-it-works-section">
      <div className="how-it-works-container">
        <div className="section-header">
          <h2 className="section-title">{t('howItWorks.title')}</h2>
          <p className="section-subtitle">
            {t('howItWorks.subtitle')}
          </p>
        </div>
        
        <div className="steps-grid">
          {steps.map((step, index) => {
            const Icon = iconMap[step.number];
            return (
              <div key={index} className="step-card">
                <div className="step-number">{step.number}</div>
                <div className="step-icon">
                  <Icon size={32} />
                </div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;